import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import Clickable from "@insite/mobius/Clickable";
import Icon from "@insite/mobius/Icon";
import XCircle from "@insite/mobius/Icons/XCircle";
import Typography from "@insite/mobius/Typography";
import ProductQuantityWrapper from "@thkStore/Overrides/Components/ProductQuantityWrapper";
import React from "react";
import styled from "styled-components";

const CardWrapper = styled.div`
    background-color: #EBEBEB;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px;
    border-radius: 4px;
`;

const CardHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
`;

const ProductInfo = styled.div`
    flex: 1;
    min-width: 0;
`;

const TraitList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-top: 4px;
`;

const AttributeList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-top: 4px;
`;

const RemoveButton = styled(Clickable)`
    flex-shrink: 0;
`;

interface Props {
    product: ProductModel;
    qtyOrdered: number;
    onQuantityChange: (qty: number) => void;
    onRemove: () => void;
}

const IncludeProductCard: React.FC<Props> = ({ product, qtyOrdered, onQuantityChange, onRemove }) => {
    const traits = product.childTraitValues ?? [];
    const attributes = product.attributeTypes?.filter(attr => attr.name?.toLocaleLowerCase() === "days to ship") ?? [];

    return (
        <CardWrapper data-test-selector={`includeProductCard_${product.id}`}>
            <CardHeader>
                <ProductInfo>
                    <Typography weight="bold" size={14}>{product.productTitle}</Typography>                    
                    {traits.length > 0 && (
                        <TraitList>
                            {traits.map(trait => (
                                <Typography key={trait.id}>
                                    {trait.valueDisplay}
                                </Typography>
                            ))}
                        </TraitList>
                    )}
                    {attributes.length > 0 && (
                        <AttributeList>
                            <Typography>{`${product.unitListPriceDisplay}`}{ product.unitOfMeasures ? ` / ${product.unitOfMeasures[0].unitOfMeasureDisplay}` : ""}</Typography>
                            {attributes.map(attr => (
                                <Typography key={attr.id}>
                                    {attr.label}: {attr.attributeValues?.map(v => v.value).join(", ")}
                                </Typography>
                            ))}
                        </AttributeList>
                    )}
                </ProductInfo>
                <RemoveButton
                    onClick={onRemove}
                    data-test-selector={`removeInclude_${product.id}`}
                >
                    <Icon src={XCircle} size={15} />
                </RemoveButton>
            </CardHeader>
            <ProductQuantityWrapper
                value={qtyOrdered}
                onChange={onQuantityChange}
                min={1}
                dataTestSelector={`includeQty_${product.id}`}
            />
        </CardWrapper>
    );
};

export default IncludeProductCard;
